// PeptideVault v6.5 — Search, sparklines, ICS, AI, PDF, alerts

// ══════════════════════════════════════════════════════
// GLOBAL SEARCH — Cmd+K Spotlight
// ══════════════════════════════════════════════════════
var _searchOpen = false, _searchQuery = '', _searchResults = [], _searchFocusIdx = 0

function openSearch() {
  _searchOpen = true; _searchQuery = ''; _searchResults = []; _searchFocusIdx = 0
  renderSearchOverlay()
  requestAnimationFrame(function() { var inp = document.getElementById('spotlight-input'); if (inp) inp.focus() })
}
function closeSearch() {
  _searchOpen = false; var el = document.getElementById('search-spotlight'); if (el) el.remove()
}
function performSearch(query) {
  _searchQuery = query
  if (!query || query.length < 2) { _searchResults = []; return }
  var q = query.toLowerCase(), results = []
  S.peptides.forEach(function(p) {
    if ((p.name||'').toLowerCase().indexOf(q) >= 0 || (p.sequence||'').toLowerCase().indexOf(q) >= 0)
      results.push({ type:'peptide', icon:'\uD83D\uDC89', name:p.name, meta:peptideQty(p)+' in stock', action:function(){S.tab='peptides';S.selectedPeptide=p.id;closeSearch();render()} })
    ;(p.skus||[]).forEach(function(sk) {
      if ((sk.barcode||'').toLowerCase().indexOf(q)>=0||(sk.vendor||'').toLowerCase().indexOf(q)>=0||(sk.lotNumber||'').toLowerCase().indexOf(q)>=0)
        results.push({type:'peptide',icon:'\uD83C\uDFF7\uFE0F',name:p.name+' \u2014 '+(sk.vendor||'SKU'),meta:sk.barcode||sk.lotNumber||'',action:function(){S.tab='peptides';S.selectedPeptide=p.id;closeSearch();render()}})
    })
  })
  S.supplements.forEach(function(s) {
    if ((s.name||'').toLowerCase().indexOf(q)>=0||(s.brand||'').toLowerCase().indexOf(q)>=0||(s.category||'').toLowerCase().indexOf(q)>=0)
      results.push({type:'supplement',icon:'\uD83D\uDC8A',name:s.name,meta:(s.quantityOnHand||0)+' on hand \u00B7 '+(s.brand||''),action:function(){S.tab='supplements';closeSearch();render()}})
  })
  ;(S.supplementLabelReviews||[]).filter(function(review){return review.status==='reviewed'}).forEach(function(review){
    var product=(S.supplements||[]).find(function(item){return item.id===review.supplementId})
    ;(review.facts&&review.facts.ingredients||[]).forEach(function(ingredient){
      var haystack=[ingredient.name,ingredient.form,ingredient.blendName].join(' ').toLowerCase()
      if(haystack.indexOf(q)>=0) results.push({type:'ingredient',icon:'◫',name:ingredient.name||'Ingredient',meta:(product&&product.name||'Supplement')+' · '+(ingredient.quantityKnown?ingredient.amount+' '+(ingredient.unit||''):'quantity unknown'),action:function(){S.tab='supplements';S._suppIntelligenceId=review.supplementId;closeSearch();render()}})
    })
  })
  ;(S.preparationBatches||[]).forEach(function(batch){
    var label=[batch.person,(batch.slots||[]).join(' '),batch.status].join(' ')
    if(label.toLowerCase().indexOf(q)>=0) results.push({type:'preparation',icon:'▣',name:(batch.person||'Pack')+' · '+(batch.slots||[]).join(' + '),meta:(batch.packCount||0)+' packs · '+(batch.status||''),action:function(){S.tab='pillpacks';S._activePreparationBatchId=batch.status==='draft'?batch.id:'';closeSearch();render()}})
  })
  ;(S.vendors||[]).forEach(function(v) {
    if ((v.name||'').toLowerCase().indexOf(q)>=0||(v.website||'').toLowerCase().indexOf(q)>=0||(v.notes||'').toLowerCase().indexOf(q)>=0)
      results.push({type:'vendor',icon:'\uD83C\uDFEA',name:v.name,meta:v.website||'',action:function(){S.tab='vendors';closeSearch();render()}})
  })
  ;(S.injectionSupplies||[]).forEach(function(sup) {
    if ((sup.name||'').toLowerCase().indexOf(q)>=0) results.push({type:'supply',icon:'\uD83D\uDCE6',name:sup.name,meta:sup.category||'',action:function(){S.tab='injsupplies';closeSearch();render()}})
  })
  S.documents.forEach(function(d) {
    if ((d.name||'').toLowerCase().indexOf(q)>=0) results.push({type:'document',icon:'\uD83D\uDCC4',name:d.name,meta:docTypeName(d.type),action:function(){S.tab='docs';closeSearch();render()}})
  })
  S.notes.forEach(function(n) {
    if ((n.title||'').toLowerCase().indexOf(q)>=0||(n.body||'').toLowerCase().indexOf(q)>=0) results.push({type:'note',icon:'\uD83D\uDCDD',name:n.title,meta:fmt(n.date),action:function(){S.tab='notes';closeSearch();render()}})
  })
  ;(S.blends||[]).forEach(function(b) {
    if ((b.name||'').toLowerCase().indexOf(q)>=0) results.push({type:'blend',icon:'\uD83E\uDDEA',name:b.name,meta:(b.components||[]).length+' components',action:function(){S.tab='blends';closeSearch();render()}})
  })
  ;(S.peptideLibrary||[]).forEach(function(l) {
    if ((l.scientificName||'').toLowerCase().indexOf(q)>=0||(l.customVialName||'').toLowerCase().indexOf(q)>=0||(l.aliases||[]).some(function(a){return a.toLowerCase().indexOf(q)>=0}))
      results.push({type:'library',icon:'\uD83D\uDCDA',name:l.scientificName||l.customVialName,meta:(l.categories||[]).join(', '),action:function(){S.tab='library';closeSearch();render()}})
  })
  ;(S.coas||[]).forEach(function(c) {
    var vendorName = ''; var v = (S.vendors||[]).find(function(vv){return vv.id===c.vendorId}); if (v) vendorName = v.name
    if ((c.reportNo||'').toLowerCase().indexOf(q)>=0||(c.testLab||'').toLowerCase().indexOf(q)>=0||vendorName.toLowerCase().indexOf(q)>=0)
      results.push({type:'coa',icon:'\uD83D\uDCDC',name:c.reportNo||'COA',meta:(c.testLab||'')+(vendorName?' · '+vendorName:''),action:function(){S.tab='coas';showCoaDetail(c.id);closeSearch()}})
  })
  _searchResults = results.slice(0, 20); _searchFocusIdx = 0
}
function renderSearchOverlay() {
  var el = document.getElementById('search-spotlight')
  if (!el) { el = document.createElement('div'); el.id = 'search-spotlight'; el.className = 'search-spotlight'; el.addEventListener('click',function(e){if(e.target===el)closeSearch()}); document.body.appendChild(el) }
  var grouped = {}, typeLabels = {peptide:'Peptides',supplement:'Supplements',ingredient:'Ingredients',preparation:'Preparation batches',vendor:'Vendors',supply:'Supplies',document:'Documents',note:'Notes',blend:'Blends',library:'Library',coa:'COAs'}
  _searchResults.forEach(function(r) { if (!grouped[r.type]) grouped[r.type] = []; grouped[r.type].push(r) })
  var idx = 0, rhtml = ''
  if (_searchResults.length > 0) {
    Object.keys(grouped).forEach(function(type) {
      rhtml += '<div class="search-group-label">' + (typeLabels[type]||type) + '</div>'
      grouped[type].forEach(function(item) {
        var fidx = _searchResults.indexOf(item)
        rhtml += '<div class="search-result-item'+(idx===_searchFocusIdx?' focused':'')+'" onclick="_searchResults['+fidx+'].action()" data-idx="'+idx+'">' +
          '<div class="sr-icon" style="background:var(--bg4)">' + item.icon + '</div>' +
          '<div style="flex:1;min-width:0"><div class="sr-name truncate">' + esc(item.name) + '</div><div class="sr-meta truncate">' + esc(item.meta) + '</div></div></div>'
        idx++
      })
    })
  } else if (_searchQuery.length >= 2) { rhtml = '<div style="padding:24px;text-align:center;color:var(--text4)">No results for "'+esc(_searchQuery)+'"</div>' }
  el.innerHTML = '<div class="search-box"><div style="position:relative"><svg class="search-box-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="8" cy="8" r="5.5"/><line x1="12" y1="12" x2="16" y2="16"/></svg><input id="spotlight-input" class="search-box-input" type="text" placeholder="Search peptides, supplements, vendors\u2026" value="'+esc(_searchQuery)+'" oninput="performSearch(this.value);renderSearchOverlay()" onkeydown="searchKeyHandler(event)" autocomplete="off" spellcheck="false"></div>'+(rhtml?'<div class="search-results">'+rhtml+'</div>':'')+'<div class="search-hint"><span><kbd>\u2191\u2193</kbd> Navigate</span><span><kbd>\u23CE</kbd> Open</span><span><kbd>esc</kbd> Close</span></div></div>'
}
function searchKeyHandler(e) {
  if (e.key==='Escape') { e.preventDefault(); closeSearch() }
  else if (e.key==='ArrowDown') { e.preventDefault(); _searchFocusIdx=Math.min(_searchFocusIdx+1,_searchResults.length-1); renderSearchOverlay() }
  else if (e.key==='ArrowUp') { e.preventDefault(); _searchFocusIdx=Math.max(_searchFocusIdx-1,0); renderSearchOverlay() }
  else if (e.key==='Enter') { e.preventDefault(); if (_searchResults[_searchFocusIdx]) _searchResults[_searchFocusIdx].action() }
}

// ══════════════════════════════════════════════════════
// SPARKLINE SVG
// ══════════════════════════════════════════════════════
function sparklineSVG(dataPoints, color, width, height) {
  width = width || 64; height = height || 20
  if (!dataPoints || dataPoints.length < 2) return ''
  var mx = Math.max.apply(null, dataPoints.concat([1])), mn = Math.min.apply(null, dataPoints.concat([0])), rng = mx-mn||1
  var pad=2, w=width-pad*2, h=height-pad*2
  var pts = dataPoints.map(function(v,i) { return (pad+(i/(dataPoints.length-1))*w).toFixed(1)+','+(pad+h-((v-mn)/rng)*h).toFixed(1) })
  var last = pts[pts.length-1].split(',')
  return '<svg width="'+width+'" height="'+height+'" viewBox="0 0 '+width+' '+height+'" style="display:block;margin:6px auto 0"><polyline points="'+pts.join(' ')+'" fill="none" stroke="'+color+'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity=".65"/><circle cx="'+last[0]+'" cy="'+last[1]+'" r="2" fill="'+color+'"/></svg>'
}
function getDailyInjectionCounts(days, userId) {
  var counts = []
  for (var d=days-1;d>=0;d--) { var dt=localDateOffset(-d); counts.push((S.injections||[]).filter(function(inj){return inj.date===dt&&(!userId||!inj.userId||inj.userId===userId)}).length) }
  return counts
}
function getSupplementTrend(days) {
  var active=(S.supplements||[]).filter(function(s){return(s.status||'active')==='active'})
  var totalNow=active.reduce(function(a,s){return a+(s.quantityOnHand||0)},0), dailyBurn=active.reduce(function(a,s){return a+(s.dailyServing||0)},0)
  return Array.from({length:days},function(_,d){return Math.max(0,totalNow+dailyBurn*(days-1-d))})
}

// ══════════════════════════════════════════════════════
// ICS CALENDAR EXPORT
// ══════════════════════════════════════════════════════
function generateICS(events) {
  var pad2=function(n){return String(n).padStart(2,'0')}
  var toD=function(ds,ts){var d=new Date(ds+'T'+(ts||'09:00'));return d.getFullYear()+pad2(d.getMonth()+1)+pad2(d.getDate())+'T'+pad2(d.getHours())+pad2(d.getMinutes())+'00'}
  var ics='BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//PeptideVault//v6.5//EN\r\n'
  events.forEach(function(e){ics+='BEGIN:VEVENT\r\nUID:'+uid()+'@pv\r\nDTSTART:'+toD(e.date,e.time)+'\r\nSUMMARY:'+(e.summary||'').replace(/[\n,;]/g,' ')+'\r\n';if(e.description)ics+='DESCRIPTION:'+e.description.replace(/\n/g,'\\n').replace(/[,;]/g,' ')+'\r\n';ics+='END:VEVENT\r\n'})
  return ics+'END:VCALENDAR'
}
function exportInjectionICS(startDate, endDate, userId) {
  var events=(S.injections||[]).filter(function(i){return i.date>=startDate&&i.date<=endDate&&(!userId||!i.userId||i.userId===userId)}).map(function(i){return{date:i.date,time:i.time||'09:00',summary:'Injection: '+(i.peptideName||''),description:'Dosage: '+(i.dosage||'N/A')+' | Site: '+(i.site||'N/A')}})
  downloadICS(events,'PeptideVault_Injections.ics')
}
function exportProtocolICS(userId) {
  var events=[], today=new Date()
  S.peptides.forEach(function(p){if(p.archived)return;(p.dosageProtocols||[]).forEach(function(dp){if(!dp.active)return;var f=(dp.frequency||'').toLowerCase(),gap=7;if(f.indexOf('daily')>=0||f.indexOf('ed')>=0)gap=1;else if(f.indexOf('eod')>=0||f.indexOf('every other')>=0)gap=2;else if(f.indexOf('3x')>=0||f.indexOf('mwf')>=0)gap=2;else if(f.indexOf('2x')>=0||f.indexOf('twice')>=0)gap=3;else if(f.indexOf('weekly')>=0)gap=7;for(var d=0;d<90;d+=Math.max(1,Math.round(gap))){var dt=new Date(today.getTime()+d*86400000);events.push({date:localDateStr(dt),time:'09:00',summary:p.name+' \u2014 '+(dp.dosage||''),description:'Protocol: '+(dp.frequency||'')+' via '+(dp.route||'')})}})})
  downloadICS(events,'PeptideVault_Protocol_Schedule.ics')
}
function downloadICS(events, filename) {
  if (!events.length) { showToast('No events to export'); return }
  var blob=new Blob([generateICS(events)],{type:'text/calendar'})
  var a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=filename;document.body.appendChild(a);a.click();document.body.removeChild(a)
  showToast('Exported '+events.length+' events')
}

// ══════════════════════════════════════════════════════
// AI PROTOCOL ASSISTANT
// ══════════════════════════════════════════════════════
function openAIAssistant() { openModal('ai-assistant',{mode:'protocol-review',query:'',response:'',loading:false}) }
async function runAIAssistant() {
  var md=S.modalData
  if (!hasAnthropicCredential()) { showToast('Configure AI in Settings first'); return }
  md.loading=true; md.response=''; render()
  var aiCtx = typeof buildAIContext === 'function' ? buildAIContext() : {}
  var contextEnvelope = typeof buildAIContextEnvelope === 'function' ? buildAIContextEnvelope() : { module:S.tab||'unknown', sourceRefs:[] }
  aiCtx.currentContext = contextEnvelope
  // Item 25: Enrich context with tool function results
  if (typeof AI_TOOLS !== 'undefined') {
    try {
      aiCtx.inventoryForecast = AI_TOOLS.getInventoryForecast(90)
      aiCtx.purchasePlan = AI_TOOLS.getPurchasePlan()
      aiCtx.dataHealthIssues = AI_TOOLS.getDataHealthIssues()
    } catch(e) {}
  }
  // Item 27: Include source references for attribution
  var sourceRefs = []
  ;(S.protocols||[]).filter(function(p){return p.status==='active'}).forEach(function(p){ sourceRefs.push({type:'protocol',id:p.id,name:p.name||p.peptideName}) })
  ;(S.labResults||[]).slice(-3).forEach(function(l){ sourceRefs.push({type:'lab',id:l.id,name:l.panelName+' '+l.date}) })
  aiCtx.sourceRefs = sourceRefs
  var sys='You are a peptide and supplement research assistant. Provide evidence-based information. Note when medical supervision is needed. Be concise. Use the provided PeptideVault data as your source — do not independently recalculate. Cite every factual PeptideVault claim with its exact supplied token such as [protocol:id], [lab:id], [peptide:id], or [inventory:id]. End with a Sources line containing only tokens actually used. Current module: '+contextEnvelope.module+'.\n\nContext:\n'+JSON.stringify(aiCtx)
  var prompts={'protocol-review':'Review my peptide protocols and supplement stack. Flag interactions, timing conflicts, optimization opportunities.','lab-analysis':'Analyze my most recent lab results in context of my protocols. Highlight out-of-range markers and suggest adjustments.','optimization':'Suggest specific optimizations: timing, dosage, missing support supplements, protocol modifications.','custom':md.query||'General review.'}
  // Item 25: Use tool-enabled assistant if available
  var result = typeof aiAssistantWithTools === 'function'
    ? await aiAssistantWithTools([{ role: 'user', content: prompts[md.mode] }], sys)
    : await aiSendRequest({ system: sys, messages: [{ role: 'user', content: prompts[md.mode] }], feature: 'ai-assistant-' + md.mode })
  md.response = result.ok ? result.content || 'No response' : 'Error: ' + result.error
  md.loading=false; render()
}
function renderMarkdown(text) {
  return esc(text).replace(/\*\*(.+?)\*\*/g,'<strong>$1</strong>').replace(/\*(.+?)\*/g,'<em>$1</em>').replace(/`(.+?)`/g,'<code style="background:var(--bg4);padding:1px 5px;border-radius:3px;font-family:var(--mono);font-size:12px">$1</code>').replace(/^### (.+)$/gm,'<h4 style="font-size:14px;font-weight:700;margin:14px 0 6px;color:var(--text)">$1</h4>').replace(/^## (.+)$/gm,'<h3 style="font-size:15px;font-weight:700;margin:16px 0 8px;color:var(--text)">$1</h3>').replace(/^- (.+)$/gm,'<div style="padding-left:16px;position:relative;margin:3px 0"><span style="position:absolute;left:4px;color:var(--accent)">&bull;</span>$1</div>').replace(/\n\n/g,'<br><br>').replace(/\n/g,'<br>')
    .replace(/\[protocol:([A-Za-z0-9_-]+)\]/g,'<a style="color:var(--accent);cursor:pointer;font-family:var(--mono)" onclick="openModal(\'editProtocol\',{protocolId:\'$1\'})">[protocol:$1]</a>')
    .replace(/\[peptide:([A-Za-z0-9_-]+)\]/g,'<a style="color:var(--accent);cursor:pointer;font-family:var(--mono)" onclick="S.selectedPeptide=\'$1\';setTab(\'peptides\')">[peptide:$1]</a>')
    .replace(/\[lab:([A-Za-z0-9_-]+)\]/g,'<a style="color:var(--accent);cursor:pointer;font-family:var(--mono)" onclick="setTab(\'labs\')">[lab:$1]</a>')
    // Item 27: Make protocol/lab/peptide references clickable
    .replace(/\b(Protocol|protocol):\s*([^\n<]+)/g, function(m, prefix, name) {
      var proto = (S.protocols||[]).find(function(p) { return (p.name||'').indexOf(name.trim()) >= 0 })
      return proto ? '<a style="color:var(--accent);cursor:pointer" onclick="openModal(\'editProtocol\',{protocolId:\'' + proto.id + '\'})">' + prefix + ': ' + name + '</a>' : m
    })
    .replace(/\b(Lot|lot):\s*([A-Z0-9\-]+)/g, '<span style="color:var(--accent);cursor:pointer" onclick="setTab(\'peptides\')">$1: $2</span>')
}

// ══════════════════════════════════════════════════════
// PDF DOCUMENT BUILDER (with comprehensive vendor support)
// ══════════════════════════════════════════════════════
function openPDFBuilder() {
  openModal('pdf-builder',{title:'PeptideVault Report',sections:{protocolSummary:true,supplementSchedule:true,inventoryPeptides:false,inventorySupplements:false,inventorySupplies:false,injectionLog:false,labResults:false,vendorDirectory:false},dateStart:localDateOffset(-90),dateEnd:localDateKey(),userId:S._dashboardUser||(S.users||[])[0]?.id||'',includeHeader:true,includeFooter:true})
}
function buildPDFContent() {
  var md=S.modalData,sec=md.sections,userName=(S.users||[]).find(function(u){return u.id===md.userId})
  userName=userName?userName.name:'All'
  var today=new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'})
  var th=function(cols){return'<tr>'+cols.map(function(c){return'<th>'+c+'</th>'}).join('')+'</tr>'}
  var h=''
  if(md.includeHeader)h+='<div style="display:flex;align-items:center;gap:16px;margin-bottom:24px;padding-bottom:16px;border-bottom:2px solid #635bff"><div style="width:44px;height:44px;background:linear-gradient(135deg,#635bff,#8b5cf6);border-radius:10px;display:flex;align-items:center;justify-content:center"><svg width="22" height="22" viewBox="0 0 20 20" fill="white"><path d="M10 2a8 8 0 100 16A8 8 0 0010 2zm0 2a6 6 0 110 12A6 6 0 0110 4zm-1 3v3H6v2h3v3h2v-3h3v-2h-3V7H9z"/></svg></div><div><div style="font-size:22px;font-weight:800;color:#111">'+esc(md.title)+'</div><div style="font-size:12px;color:#666">'+esc(userName)+' &middot; '+today+'</div></div></div>'
  if(sec.protocolSummary){var pr=[];S.peptides.forEach(function(p){if(p.archived)return;(p.dosageProtocols||[]).forEach(function(dp){if(dp.active)pr.push({n:p.name,dosage:dp.dosage,frequency:dp.frequency,route:dp.route,notes:dp.notes})})});h+='<h2>Active Protocols</h2><table>'+th(['Peptide','Dosage','Frequency','Route','Notes'])+pr.map(function(p){return'<tr><td style="font-weight:600">'+esc(p.n)+'</td><td>'+esc(p.dosage||'')+'</td><td>'+esc(p.frequency||'')+'</td><td>'+esc(p.route||'')+'</td><td>'+esc(p.notes||'')+'</td></tr>'}).join('')+'</table>'}
  if(sec.supplementSchedule){var ac=(S.supplements||[]).filter(function(s){return(s.status||'active')==='active'}),am=ac.filter(function(s){return s.timeOfDay==='am'||s.timeOfDay==='both'}),noon=ac.filter(function(s){return s.timeOfDay==='noon'}),pm=ac.filter(function(s){return s.timeOfDay==='pm'||s.timeOfDay==='both'}),rows=function(items,time){return items.map(function(s){return'<tr><td style="font-weight:600">'+esc(s.name)+'</td><td>'+esc(s.strength||'')+'</td><td>'+suppServingForTime(s,time)+' '+esc(s.form||'')+'</td><td>'+esc(s.brand||'')+'</td></tr>'}).join('')};h+='<h2>Supplement Schedule</h2><h3 style="color:#635bff">Morning ('+am.length+')</h3><table>'+th(['Name','Strength','Serving','Brand'])+rows(am,'am')+'</table><h3 style="color:#0f766e">Noon / Lunch ('+noon.length+')</h3><table>'+th(['Name','Strength','Serving','Brand'])+rows(noon,'noon')+'</table><h3 style="color:#635bff">Evening ('+pm.length+')</h3><table>'+th(['Name','Strength','Serving','Brand'])+rows(pm,'pm')+'</table>'}
  if(sec.inventoryPeptides){h+='<h2>Peptide Inventory</h2><table>'+th(['Name','Qty','Status','Vendors'])+S.peptides.map(function(p){var vSet={};(p.skus||[]).forEach(function(s){if(s.vendor)vSet[s.vendor]=true});var v=Object.keys(vSet).join(', '),q=peptideQty(p);return'<tr><td style="font-weight:600">'+esc(p.name)+'</td><td>'+q+'</td><td>'+(p.archived?'Inactive':q<=0?'Out':'Active')+'</td><td>'+esc(v)+'</td></tr>'}).join('')+'</table>'}
  if(sec.inventorySupplements){h+='<h2>Supplement Inventory</h2><table>'+th(['Name','Strength','Brand','On Hand','Status'])+S.supplements.map(function(s){return'<tr><td style="font-weight:600">'+esc(s.name)+'</td><td>'+esc(s.strength||'')+'</td><td>'+esc(s.brand||'')+'</td><td>'+(s.quantityOnHand||0)+'</td><td>'+(s.status||'active')+'</td></tr>'}).join('')+'</table>'}
  if(sec.inventorySupplies){h+='<h2>Injection Supplies</h2><table>'+th(['Name','Category','Total Qty'])+(S.injectionSupplies||[]).map(function(s){return'<tr><td style="font-weight:600">'+esc(s.name)+'</td><td>'+esc(s.category||'')+'</td><td>'+injSupplyTotalQty(s)+'</td></tr>'}).join('')+'</table>'}
  if(sec.injectionLog){var injs=(S.injections||[]).filter(function(i){return i.date>=md.dateStart&&i.date<=md.dateEnd}).sort(function(a,b){return b.date.localeCompare(a.date)});h+='<h2>Injection Log ('+md.dateStart+' to '+md.dateEnd+')</h2><table>'+th(['Date','Time','Peptide','Dosage','Site'])+injs.map(function(i){return'<tr><td>'+i.date+'</td><td>'+esc(i.time||'')+'</td><td style="font-weight:600">'+esc(i.peptideName||'')+'</td><td>'+esc(i.dosage||'')+'</td><td>'+esc(i.site||'')+'</td></tr>'}).join('')+'</table><div style="font-size:11px;color:#999">'+injs.length+' entries</div>'}
  if(sec.labResults){(S.labResults||[]).sort(function(a,b){return b.date.localeCompare(a.date)}).slice(0,5).forEach(function(lab){h+='<h2>'+esc(lab.panelName||'Lab Panel')+' &mdash; '+lab.date+'</h2><table>'+th(['Marker','Value','Unit','Ref Low','Ref High','Status'])+(lab.markers||[]).map(function(m){var v=parseFloat(m.value),lo=parseFloat(m.refLow),hi=parseFloat(m.refHigh),st='&mdash;',c='#111';if(!isNaN(v)&&!isNaN(lo)&&v<lo){st='Low';c='#dc2626'}else if(!isNaN(v)&&!isNaN(hi)&&v>hi){st='High';c='#dc2626'}else if(!isNaN(v)&&!isNaN(lo)&&!isNaN(hi)){st='Normal';c='#059669'};return'<tr><td style="font-weight:600">'+esc(m.name)+'</td><td>'+esc(m.value)+'</td><td>'+esc(m.unit||'')+'</td><td>'+(m.refLow||'&mdash;')+'</td><td>'+(m.refHigh||'&mdash;')+'</td><td style="color:'+c+';font-weight:600">'+st+'</td></tr>'}).join('')+'</table>'})}
  if(sec.vendorDirectory){var vendors=(S.vendors||[]).sort(function(a,b){return(a.name||'').localeCompare(b.name||'')});h+='<h2>Vendor Directory ('+vendors.length+')</h2><table>'+th(['Name','Website','Email','Telegram','Notes'])+vendors.map(function(v){var links=(v.links&&v.links.length)?v.links:(v.website?[{label:'Website',url:v.website}]:[]);var webUrl=links.length?links[0].url:'';return'<tr><td style="font-weight:600">'+esc(v.name)+'</td><td>'+esc(webUrl)+'</td><td>'+esc(v.email||'')+'</td><td>'+esc(v.telegram||'')+'</td><td>'+esc(v.notes||'')+'</td></tr>'}).join('')+'</table>'}
  if(md.includeFooter)h+='<div style="margin-top:32px;padding-top:12px;border-top:1px solid #ddd;font-size:10px;color:#999;display:flex;justify-content:space-between"><span>PeptideVault v6.5</span><span>'+today+'</span></div>'
  return h
}
function printPDFBuilder() {
  var html=buildPDFContent(),w=window.open('','_blank','width=900,height=700')
  if(!w){showToast('Pop-up blocked');return}
  w.document.write('<!DOCTYPE html><html><head><title>'+esc(S.modalData.title)+'</title><style>*{box-sizing:border-box}body{font-family:-apple-system,system-ui,sans-serif;padding:40px 48px;max-width:900px;margin:0 auto;color:#111;font-size:13px;line-height:1.6}h2{font-size:16px;font-weight:800;margin:28px 0 10px;border-bottom:1px solid #e5e5e5;padding-bottom:6px}h3{font-size:13px;font-weight:700;margin:14px 0 6px}table{width:100%;border-collapse:collapse;margin:6px 0 16px;font-size:12px}th{text-align:left;padding:8px 10px;background:#f8f8fa;border:1px solid #e5e5e5;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.3px;color:#555}td{padding:7px 10px;border:1px solid #e5e5e5}tr:nth-child(even) td{background:#fafafa}@media print{body{padding:20px}}</style></head><body>'+html+'</body></html>')
  w.document.close();setTimeout(function(){w.print()},400)
}

// ══════════════════════════════════════════════════════
// BURN RATE + SHOPPING LIST
// ══════════════════════════════════════════════════════
function calcBurnRate(s) { return suppDailyBurn(s) }
function calcDaysUntilEmpty(s) { var b=calcBurnRate(s); return b<=0?Infinity:Math.floor(+(s.quantityOnHand||0)/b) }
function getShoppingList() {
  var items=[]
  S.supplements.forEach(function(s){if(typeof suppNeedsRestockAlert==='function'&&!suppNeedsRestockAlert(s))return;if((s.status||'active')==='inactive')return;var days=calcDaysUntilEmpty(s),thresh=+(s.lowStockDays||14);if(days<=thresh)items.push({name:s.name,type:'Supplement',daysLeft:days,brand:s.brand||'',strength:s.strength||'',reorderUrl:s.reorderUrl||'',urgency:days<=3?'critical':days<=7?'urgent':'soon'})})
  S.peptides.forEach(function(p){if(p.archived)return;var thresh=+(p.lowStockThreshold||0),qty=peptideQty(p);if(thresh>0&&qty<=thresh)items.push({name:p.name,type:'Peptide',qty:qty,urgency:qty<=0?'critical':qty<=1?'urgent':'soon'})})
  ;(S.injectionSupplies||[]).forEach(function(sup){var thresh=+(sup.lowStockThreshold||0),qty=injSupplyTotalQty(sup);if(thresh>0&&qty<=thresh)items.push({name:sup.name,type:'Supply',qty:qty,urgency:qty<=0?'critical':'soon'})})
  items.sort(function(a,b){var o={critical:0,urgent:1,soon:2};return(o[a.urgency]||2)-(o[b.urgency]||2)})
  return items
}
function openShoppingList() { openModal('shopping-list',{items:getShoppingList()}) }

// ══════════════════════════════════════════════════════
// PROTOCOL ADHERENCE
// ══════════════════════════════════════════════════════
function getProtocolAdherence(peptideName, frequency, days) {
  days=days||30;var start=localDateOffset(-days),end=localDateKey()
  var actual=(S.injections||[]).filter(function(inj){return inj.peptideName===peptideName&&inj.date>=start&&inj.date<=end}).length
  var f=(frequency||'').toLowerCase(),pw=1;if(f.indexOf('daily')>=0)pw=7;else if(f.indexOf('eod')>=0||f.indexOf('every other')>=0)pw=3.5;else if(f.indexOf('3x')>=0||f.indexOf('mwf')>=0)pw=3;else if(f.indexOf('2x')>=0||f.indexOf('twice')>=0)pw=2;else if(f.indexOf('weekly')>=0)pw=1
  var expected=Math.round(pw*days/7),pct=expected>0?Math.min(Math.round(actual/expected*100),100):0
  return{actual:actual,expected:expected,pct:pct}
}
function renderAdherenceBar(pct) {
  var c=pct>=85?'var(--green)':pct>=60?'var(--yellow)':'var(--red)'
  return'<div style="display:flex;align-items:center;gap:8px"><div style="flex:1;height:6px;background:var(--bg4);border-radius:3px;overflow:hidden"><div style="height:100%;width:'+pct+'%;background:'+c+';border-radius:3px;transition:width .3s ease"></div></div><span style="font-size:12px;font-weight:700;color:'+c+';min-width:36px;text-align:right">'+pct+'%</span></div>'
}

// ══════════════════════════════════════════════════════
// KEYBOARD SHORTCUTS OVERLAY
// ══════════════════════════════════════════════════════
var _shortcutsOpen = false
function toggleShortcuts() { _shortcutsOpen?hideShortcutsOverlay():showShortcutsOverlay() }
function showShortcutsOverlay() {
  _shortcutsOpen=true;var el=document.getElementById('shortcuts-overlay')
  if(!el){el=document.createElement('div');el.id='shortcuts-overlay';el.className='search-spotlight';el.addEventListener('click',function(e){if(e.target===el)hideShortcutsOverlay()});document.body.appendChild(el)}
  var sc=[['Search','\u2318K'],['Save','\u2318S'],['Find in tab','\u2318F'],['Close modal','Esc'],['Shortcuts','\u2318/']]
  el.innerHTML='<div class="search-box" style="width:440px"><div style="padding:18px 24px;border-bottom:1px solid var(--border)"><div style="font-size:16px;font-weight:700;color:var(--text)">Keyboard Shortcuts</div></div><div style="padding:12px 24px">'+sc.map(function(s){return'<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid var(--border)"><span style="font-size:14px;color:var(--text)">'+s[0]+'</span><kbd style="background:var(--bg4);padding:3px 10px;border-radius:5px;font-size:12px;font-weight:700;border:1px solid var(--border2);color:var(--text2);font-family:var(--sans)">'+s[1]+'</kbd></div>'}).join('')+'</div><div style="padding:12px 24px;border-top:1px solid var(--border);font-size:12px;color:var(--text4)">Press Esc to close</div></div>'
}
function hideShortcutsOverlay() { _shortcutsOpen=false;var el=document.getElementById('shortcuts-overlay');if(el)el.remove() }

// ══════════════════════════════════════════════════════
// SCAN → LOG INJECTION
// ══════════════════════════════════════════════════════
function scanLogInjection(peptideId, peptideName, skuVendor) {
  closeSearch(); openModal('scan-log-injection',{peptideId:peptideId,peptideName:peptideName,date:localDateKey(),time:new Date().toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit',hour12:false}),dosage:'',drawUnits:'',site:'',vendor:skuVendor||''})
}
async function saveScanInjection() {
  var md=S.modalData;if(!md.peptideId||!md.date){showToast('Date required');return}
  S.injections.push({id:uid(),peptideId:md.peptideId,peptideName:md.peptideName,date:md.date,time:md.time||'',dosage:md.dosage||'',drawUnits:md.drawUnits||'',site:md.site||'',userId:S._dashboardUser||(S.users||[])[0]?.id||'',notes:'Logged via barcode scan'})
  await save();closeModal();showToast('Injection logged: '+md.peptideName);render()
}

// ══════════════════════════════════════════════════════
// CONFLICT RESOLUTION
// ══════════════════════════════════════════════════════
var _conflictData = null
function detectConflicts(localData, cloudData) {
  var conflicts=[];SYNC_KEYS.forEach(function(key){var local=localData[key]||[],cloud=cloudData[key]||[];if(JSON.stringify(local)===JSON.stringify(cloud))return;var localIds={},cloudIds={};local.forEach(function(i){if(i.id)localIds[i.id]=i});cloud.forEach(function(i){if(i.id)cloudIds[i.id]=i});var added=0,removed=0,modified=0;Object.keys(cloudIds).forEach(function(id){if(!localIds[id])added++});Object.keys(localIds).forEach(function(id){if(!cloudIds[id])removed++;else if(JSON.stringify(localIds[id])!==JSON.stringify(cloudIds[id]))modified++});if(added||removed||modified)conflicts.push({key:key,localCount:local.length,cloudCount:cloud.length,added:added,removed:removed,modified:modified})});return conflicts
}
function showConflictModal(conflicts,cloudData){_conflictData={conflicts:conflicts,cloudData:cloudData};openModal('sync-conflict',{conflicts:conflicts})}
function resolveConflict(choice){if(!_conflictData){closeModal();return};if(choice==='cloud'){_conflictData.conflicts.forEach(function(c){if(_conflictData.cloudData[c.key]!==undefined)S[c.key]=_conflictData.cloudData[c.key]});save();showToast('Applied cloud version')}else if(choice==='local'){pushThenPull();showToast('Keeping local \u2014 pushing to cloud')}else if(choice==='merge'){_conflictData.conflicts.forEach(function(c){var local=S[c.key]||[],cloud=_conflictData.cloudData[c.key]||[],merged={};local.forEach(function(item){if(item.id)merged[item.id]=item});cloud.forEach(function(item){if(item.id){var existing=merged[item.id];if(!existing)merged[item.id]=item;else{var ct=item.updatedAt||item.createdAt||'',lt=existing.updatedAt||existing.createdAt||'';if(ct>lt)merged[item.id]=item}}});S[c.key]=Object.values(merged)});save();showToast('Merged: cloud + local combined')};_conflictData=null;closeModal();render()}


// ══════════════════════════════════════════════════════
// UNIFIED ALERT ENGINE
// One source of truth consumed by titlebar, sidebar, notifications, and dashboard
// ══════════════════════════════════════════════════════
function getAlerts() {
  var alerts = []
  var today = localDateKey()
  var day30 = localDateOffset(30)
  var day90 = localDateOffset(90)

  // Peptide low stock / out of stock
  S.peptides.forEach(function(p) {
    if (p.archived) return
    var hasSkus = (p.skus || []).length > 0
    if (!hasSkus) return
    var qty = peptideQty(p)
    var thr = +(p.lowStockThreshold || 0)
    if (qty <= 0) {
      alerts.push({ type: 'inventory', severity: 'critical', category: 'peptide', name: p.name, id: p.id, message: 'Out of stock', tab: 'peptides' })
    } else if (thr > 0 && qty <= thr) {
      alerts.push({ type: 'inventory', severity: 'warning', category: 'peptide', name: p.name, id: p.id, message: qty + ' ' + (p.unit || 'units') + ' remaining (threshold: ' + thr + ')', tab: 'peptides' })
    }
  })

  // Supplement low stock
  S.supplements.forEach(function(s) {
    if (typeof suppNeedsRestockAlert === 'function' ? !suppNeedsRestockAlert(s) : (s.status || 'active') === 'inactive') return
    var days = typeof suppDaysSupply === 'function' ? suppDaysSupply(s) : null
    var thresh = +(s.lowStockDays || 14)
    if (days !== null && days <= thresh) {
      alerts.push({ type: 'inventory', severity: days <= 3 ? 'critical' : 'warning', category: 'supplement', name: s.name, id: s.id, message: days + ' days supply remaining', tab: 'supplements' })
    }
  })

  // Injection supply low stock
  ;(S.injectionSupplies || []).forEach(function(sup) {
    var thr = +(sup.lowStockThreshold || 0)
    var qty = injSupplyTotalQty(sup)
    if (thr > 0 && qty <= thr) {
      alerts.push({ type: 'inventory', severity: qty <= 0 ? 'critical' : 'warning', category: 'supply', name: sup.name, id: sup.id, message: qty + ' remaining (threshold: ' + thr + ')', tab: 'injsupplies' })
    }
  })

  // Expiring items — peptides
  S.peptides.forEach(function(p) {
    ;(p.skus || []).forEach(function(sk) {
      if (!sk.expiryDate || skuQty(sk) <= 0) return
      if (sk.expiryDate <= today) {
        alerts.push({ type: 'expiry', severity: 'critical', category: 'peptide', name: p.name, message: 'EXPIRED ' + sk.expiryDate, tab: 'peptides' })
      } else if (sk.expiryDate <= day90) {
        alerts.push({ type: 'expiry', severity: sk.expiryDate <= day30 ? 'warning' : 'info', category: 'peptide', name: p.name, message: 'Expires ' + sk.expiryDate, tab: 'peptides' })
      }
    })
  })

  // Expiring — supplements
  S.supplements.forEach(function(s) {
    if (!s.expiryDate || (s.quantityOnHand || 0) <= 0) return
    if (s.expiryDate <= today) {
      alerts.push({ type: 'expiry', severity: 'critical', category: 'supplement', name: s.name, message: 'EXPIRED ' + s.expiryDate, tab: 'supplements' })
    } else if (s.expiryDate <= day90) {
      alerts.push({ type: 'expiry', severity: s.expiryDate <= day30 ? 'warning' : 'info', category: 'supplement', name: s.name, message: 'Expires ' + s.expiryDate, tab: 'supplements' })
    }
  })

  // Expiring — injection supplies
  ;(S.injectionSupplies || []).forEach(function(sup) {
    ;(sup.skus || []).forEach(function(sk) {
      if (!sk.expiryDate || injSupplyQty(sk) <= 0) return
      if (sk.expiryDate <= today) {
        alerts.push({ type: 'expiry', severity: 'critical', category: 'supply', name: sup.name, message: 'EXPIRED ' + sk.expiryDate, tab: 'injsupplies' })
      } else if (sk.expiryDate <= day90) {
        alerts.push({ type: 'expiry', severity: sk.expiryDate <= day30 ? 'warning' : 'info', category: 'supply', name: sup.name, message: 'Expires ' + sk.expiryDate, tab: 'injsupplies' })
      }
    })
  })

  // Sort: critical first, then warning, then info
  var order = { critical: 0, warning: 1, info: 2 }
  alerts.sort(function(a, b) { return (order[a.severity] || 2) - (order[b.severity] || 2) })

  return alerts
}

// Convenience accessors for specific surfaces
function getAlertCount() { return getAlerts().length }
function getAlertsByType(type) { return getAlerts().filter(function(a) { return a.type === type }) }
function getAlertsByCategory(cat) { return getAlerts().filter(function(a) { return a.category === cat }) }
function getCriticalAlertCount() { return getAlerts().filter(function(a) { return a.severity === 'critical' }).length }

// BN39: Report presets
function saveReportPreset() {
  var name = prompt('Preset name:')
  if (!name) return
  var md = S.modalData || {}
  S.reportPresets.push({ id: uid(), name: name, sections: Object.assign({}, md.sections), dateRange: { start: md.dateStart, end: md.dateEnd }, userId: md.userId, labPanel: '' })
  save(); showToast('Preset saved'); render()
}
function loadReportPreset(id) {
  var preset = (S.reportPresets || []).find(function(rp) { return rp.id === id })
  if (!preset) return
  S.modalData.sections = Object.assign({}, preset.sections || {})
  if (preset.dateRange) { S.modalData.dateStart = preset.dateRange.start || ''; S.modalData.dateEnd = preset.dateRange.end || '' }
  if (preset.userId) S.modalData.userId = preset.userId
  render()
}

function render() {
  if (typeof reconcileProtocolLifecycle === 'function') {
    var lifecycleChanges = reconcileProtocolLifecycle()
    if (lifecycleChanges.length) save()
  }
  const tabContent = {
    peptides:  renderPeptidesTab,
    locations: renderLocationsTab,
    calendar:  renderCalendarTab,
    analytics: renderAnalyticsTab,
    halflife:  renderHalfLifeTab,
    simulator: renderSimulatorTab,
    emergency: renderEmergencyCardTab,
    health:    renderHealthTab,
    notes:     renderNotesTab,
    scanner:   renderScannerTab,
    dashboard:   renderHomeHub,
    inventoryhub: renderInventoryHubV74,
    protocolshub: renderProtocolCommandCenter,
    healthhub: renderHealthHub,
    vaulthub: renderVaultHubV73,
    library:     renderPeptideLibraryTab,
    categories:  renderCategoryCardsTab,
    supplements: renderSupplementsTab,
    pillpacks:   renderPillPacksTab,
    injsupplies: renderInjSuppliesTab,
    pens:        renderPensTab,
    vendors:     renderVendorsTab,
    cycles:      renderCycleTimelineTab,
    blends:      renderBlendsTab,
    labresults:  renderLabResultsTab,
    healthdocs:  renderHealthDocsTab,
    exports:    renderExportsTab,
    templates:  renderTemplatesTab,
    calc:      renderCalcTab,
    docs:      renderDocsTab,
    changelog: renderChangeLogTab,
    settings:  renderSettingsHub,
    planner:    renderProtocolPlannerTab,
    scenarios:  renderScenarioPlanningTab,
    allocation: renderInventoryAllocationTab,
    forecast:   renderInventoryForecastTab,
    purchaseplan: renderPurchasePlanningTab,
    coas:       renderCoasTab,
    labcompare: renderLabComparisonTab,
    timeline:   renderPlanningTimelineTab,
    masterplan: renderMasterPlanImportTab,
    regimens:   renderRegimenVersionsTab,
    snapshots:  renderSnapshotsTab,
    labnorm:    renderLabNormalizationTab,
    savedviews: renderSavedViewsTab,
    audittrail: renderAuditTrailTab,
    trash:      renderTrashTab,
    datahealth: renderDataHealthTab,
    duplicates: renderDuplicateDetectionTab,
    recovery:   renderBackupRecoveryTab,
    syncstatus: renderSyncStatusTab,
    diagnostics:renderDiagnosticsTab,
    helpcenter: renderHelpCenterTab,
    dependencies: renderDependenciesHub,
    injectionhub: renderInjectionHub,
    vaultmap: renderPeptideVaultMap,
  }[S.tab] || renderDashboardTab

  // Preserve scroll position across re-renders
  const mainEl = document.querySelector('.main')
  const scrollTop = mainEl ? mainEl.scrollTop : 0

  document.getElementById('app').innerHTML = `
    <div class="layout">
      ${renderSidebar()}
      <div class="pv-workspace">
        <div class="main">${hubNavForTab(S.tab)}${tabContent()}</div>
      </div>
    </div>
    ${typeof renderBottomNav === 'function' ? renderBottomNav() : ''}
    ${renderModal()}
  `
  sortAllDropdowns(document.getElementById('app'))

  // Restore scroll position (or scroll to top on tab switch)
  const newMain = document.querySelector('.main')
  if (newMain) {
    if (S._scrollToTop) { newMain.scrollTop = 0; S._scrollToTop = false }
    else if (S._restoreListScroll && S._listScrollTop != null) { newMain.scrollTop = S._listScrollTop; S._restoreListScroll = false }
    else { newMain.scrollTop = scrollTop }
  }
  // After DOM update: run calc if on calc tab, trigger SKU save button binding
  if (S.tab === 'calc') requestAnimationFrame(calcUpdate)
  renderSyncIndicator()
  if (S.tab === 'dashboard' && S._environmentSensorStatus && S._environmentSensorStatus.state === 'idle') {
    requestAnimationFrame(function(){ refreshEnvironmentSensor().then(function(){ if (S.tab === 'dashboard') render() }) })
  }
}


// ── Command Palette entries ──
const CMD_PALETTE = [
  { label: 'Go to Dashboard', action: () => { setTab('dashboard'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Peptides', action: () => { setTab('peptides'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Calendar', action: () => { setTab('calendar'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Supplements', action: () => { setTab('supplements'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Supplies', action: () => { setTab('injsupplies'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Analytics', action: () => { setTab('analytics'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Settings', action: () => { setTab('settings'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Vendors', action: () => { setTab('vendors'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Cycles', action: () => { setTab('cycles'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Protocol Planner', action: () => { setTab('planner'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Scenario Planning', action: () => { setTab('scenarios'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Inventory Forecast', action: () => { setTab('forecast'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Inventory Allocation', action: () => { setTab('allocation'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Purchase Planning', action: () => { setTab('purchaseplan'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Planning Timeline', action: () => { setTab('timeline'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Master Plan Import', action: () => { setTab('masterplan'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Regimen History', action: () => { setTab('regimens'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Snapshots', action: () => { setTab('snapshots'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Lab Normalization', action: () => { setTab('labnorm'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Saved Views', action: () => { setTab('savedviews'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Audit Trail', action: () => { setTab('audittrail'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Trash', action: () => { setTab('trash'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Data Health', action: () => { setTab('datahealth'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Duplicates', action: () => { setTab('duplicates'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Backup & Recovery', action: () => { setTab('recovery'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Sync Status', action: () => { setTab('syncstatus'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Diagnostics', action: () => { setTab('diagnostics'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Help Center', action: () => { setTab('helpcenter'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to COAs', action: () => { setTab('coas'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Lab Comparison', action: () => { setTab('labcompare'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Lab Results', action: () => { setTab('labresults'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Scanner', action: () => { setTab('scanner'); closeSearch() }, cat: 'Navigate' },
  { label: 'Go to Calculator', action: () => { setTab('calc'); closeSearch() }, cat: 'Navigate' },
  { label: 'Add Peptide', action: () => { closeSearch(); openModal('addPeptide') }, cat: 'Actions' },
  { label: 'Add Supplement', action: () => { closeSearch(); openModal('addSupplement') }, cat: 'Actions' },
  { label: 'Add Note', action: () => { closeSearch(); openModal('addNote') }, cat: 'Actions' },
  { label: 'Add Vendor', action: () => { closeSearch(); openModal('addVendor') }, cat: 'Actions' },
  { label: 'New Protocol (Wizard)', action: () => { closeSearch(); openProtocolWizard() }, cat: 'Actions' },
  { label: 'New Protocol (Quick)', action: () => { closeSearch(); openModal('addProtocol') }, cat: 'Actions' },
  { label: 'New Scenario', action: () => { closeSearch(); openModal('addScenario') }, cat: 'Actions' },
  { label: 'Log Injection', action: () => { closeSearch(); openModal('logInjection') }, cat: 'Actions' },
  { label: 'Export Data', action: () => { closeSearch(); setTab('exports') }, cat: 'Actions' },
  { label: 'Import CSV', action: () => { closeSearch(); setTab('templates') }, cat: 'Actions' },
  { label: 'Manual Backup', action: () => { closeSearch(); manualBackupNow() }, cat: 'Actions' },
  { label: 'Toggle Theme', action: () => { closeSearch(); cycleTheme() }, cat: 'Actions' },
  { label: 'Keyboard Shortcuts', action: () => { closeSearch(); toggleShortcuts() }, cat: 'Actions' },
]

function cmdPaletteMatches(query) {
  if (!query) return CMD_PALETTE.slice(0, 8)
  const q = query.toLowerCase()
  return CMD_PALETTE.filter(c => c.label.toLowerCase().includes(q))
}

function executeCmdPalette(idx) {
  const matches = cmdPaletteMatches(S.search)
  if (matches[idx]) matches[idx].action()
}

export {
  _searchOpen,
  openSearch,
  closeSearch,
  performSearch,
  renderSearchOverlay,
  searchKeyHandler,
  sparklineSVG,
  getDailyInjectionCounts,
  getSupplementTrend,
  generateICS,
  exportInjectionICS,
  exportProtocolICS,
  downloadICS,
  openAIAssistant,
  runAIAssistant,
  renderMarkdown,
  openPDFBuilder,
  buildPDFContent,
  printPDFBuilder,
  calcBurnRate,
  calcDaysUntilEmpty,
  getShoppingList,
  openShoppingList,
  getProtocolAdherence,
  renderAdherenceBar,
  _shortcutsOpen,
  toggleShortcuts,
  showShortcutsOverlay,
  hideShortcutsOverlay,
  scanLogInjection,
  saveScanInjection,
  _conflictData,
  detectConflicts,
  showConflictModal,
  resolveConflict,
  getAlerts,
  getAlertCount,
  getAlertsByType,
  getAlertsByCategory,
  getCriticalAlertCount,
  render,
  CMD_PALETTE,
  cmdPaletteMatches,
  executeCmdPalette,
  saveReportPreset,
  loadReportPreset
}
